import { render, staticRenderFns } from "./vm-google.vue?vue&type=template&id=0e72a720&scoped=true&lang=pug&"
import script from "./vm-google.vue?vue&type=script&lang=js&"
export * from "./vm-google.vue?vue&type=script&lang=js&"
import style0 from "./vm-google.vue?vue&type=style&index=0&id=0e72a720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72a720",
  null
  
)

export default component.exports